module.exports = __webpack_public_path__ + "images/category_lp/common/icon-babble-left_ee7b602638d6ce5da180cf5b2272b344.png";